var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "div-block-25"
  }, [_c('div', {
    staticClass: "add-prijem-btn"
  }, [_c('div', {
    staticClass: "text-small bl-color pointer",
    on: {
      "click": function click($event) {
        return _vm.openPropertyTypePicker();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }